import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import {
  bumpJobChatListItem,
  normalizeJobChatMessage,
  sendJobChatMessage,
  upsertMessageInPages,
} from "../actions/jobChats.actions";
import { jobChatsQueryKeys } from "../jobChats.queryKeys";

export const useJobChatMutation = (jobEventUid, companyId = undefined) => {
  const token = sessionStorage.getItem("token");
  const queryClient = useQueryClient();
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  const messagesMutation = useMutation({
    mutationFn: (messageData) => sendJobChatMessage(token, jobEventUid, messageData, effectiveCompanyId),
    onSuccess: (created) => {
      const message = normalizeJobChatMessage(created);
      if (!message?.uid || !effectiveCompanyId) return;

      queryClient.setQueryData(jobChatsQueryKeys.messages(effectiveCompanyId, jobEventUid), (old) =>
        upsertMessageInPages(old, message)
      );

      const preview = message.content?.text ?? message.content?.name ?? null;
      const lastMessageAt = message.createdAt ?? new Date().toISOString();
      queryClient.setQueryData(jobChatsQueryKeys.active(effectiveCompanyId), (old) =>
        bumpJobChatListItem(old, jobEventUid, { lastMessage: preview, lastMessageAt, incrementUnread: false })
      );
    },
  });

  return { messagesMutation };
};
